@if (legend()) {
  <span class="bg-secondary-color w-[6px] h-6"></span>
  <p class="text-md">{{ legend() }}</p>
}
